/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Case_Type_Not_CoveredInputs */

const en_api_error_case_type_not_covered = /** @type {(inputs: Api_Error_Case_Type_Not_CoveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This client’s contract does not cover the selected case type.`)
};

const pt_br2_api_error_case_type_not_covered = /** @type {(inputs: Api_Error_Case_Type_Not_CoveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O contrato deste cliente não cobre o tipo de caso selecionado.`)
};

/**
* | output |
* | --- |
* | "This client’s contract does not cover the selected case type." |
*
* @param {Api_Error_Case_Type_Not_CoveredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_case_type_not_covered = /** @type {((inputs?: Api_Error_Case_Type_Not_CoveredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Case_Type_Not_CoveredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_case_type_not_covered(inputs)
	return pt_br2_api_error_case_type_not_covered(inputs)
});